import { FormControl, FormHelperText, InputLabel, makeStyles, OutlinedInput } from '@material-ui/core';
import React, { useEffect, useRef } from 'react';

const useStyles = makeStyles({
  root: {
    '& $notchedOutline': {
      borderColor: '#707070',
    },
  },
  focused: {},
  notchedOutline: {},
});

function AdornmentTextInput({
  id,
  label,
  type,
  onChange,
  onBlur,
  className,
  multiline,
  fullWidth = true,
  rows,
  disabled = false,
  autoFocus,
  value,
  required,
  error,
  helperText,
  getInputRef,
  onFocus,
  onClick,
  onKeyDown,
  endAdornment,
  labelWidth
}) {
  const ref = useRef(null);

  const styles = useStyles();

  const getRef = () => {
    if (getInputRef) {
      return getInputRef();
    }
    return ref;
  };
  const inputRef = getRef();

  useEffect(() => {
    if (autoFocus) {
      inputRef.current.focus();
    }
  }, [inputRef, autoFocus]);

  return (
    <FormControl error={error} variant="outlined" fullWidth={fullWidth}>
      <InputLabel required={required} shrink htmlFor="outlined-adornment-password">
        {label}
      </InputLabel>
      <OutlinedInput
        inputRef={inputRef}
        required={!!required}
        className={className}
        classes={styles}
        id={id}
        name={id}
        label={label ? `${label} ${required ? '*' : ''}` : undefined}
        labelWidth={labelWidth}
        onChange={onChange}
        endAdornment={endAdornment}
        onFocus={onFocus}
        onKeyDown={onKeyDown}
        onClick={onClick}
        onBlur={onBlur}
        value={value === undefined ? '' : value}
        fullWidth={fullWidth}
        multiline={multiline}
        rows={rows}
        variant="outlined"
        type={type}
        error={error}
        disabled={disabled}
        notched
        autoFocus={autoFocus}
        autoComplete="off"
        inputProps={{
          autoComplete: 'off',
        }}
        aria-describedby="component-error-text"
      />
      {error && <FormHelperText id="component-error-text">{helperText}</FormHelperText>}
    </FormControl>
  );
}

AdornmentTextInput.defaultProps = {
  onFocus: () => { },
  onClick: () => { },
  onKeyDown: () => { },
};

export default AdornmentTextInput;
